import React, { useState, useEffect } from 'react';
import { formatCurrency } from '../../../utils/currency';
import { useAuth } from '../../../contexts/AuthContext';
import { useTranslation } from '../../../utils/i18n';
import { loanTermAPI } from '../../../utils/api';
import './StepStyles.css';

const Step4Term = ({ formData, setFormData }) => {
  const { language } = useAuth();
  const { t } = useTranslation(language);
  const quickTerms = [3, 6, 12, 18, 24, 36];
  const [termConfig, setTermConfig] = useState(null);
  const [commissionEstimate, setCommissionEstimate] = useState(null);

  useEffect(() => {
    if (formData.termMonths) {
      fetchTermConfig(formData.termMonths);
    }
  }, [formData.termMonths]);

  // Fetch commission estimate when amount, termMonths, or bankId changes
  useEffect(() => {
    if (formData.amount > 0 && formData.termMonths > 0 && formData.bankId) {
      fetchCommissionEstimate();
    } else {
      setCommissionEstimate(null);
    }
  }, [formData.amount, formData.termMonths, formData.bankId]);

  const fetchTermConfig = async (months) => {
    try {
      const response = await loanTermAPI.getForMonths(months);
      setTermConfig(response.data.config);
    } catch (error) {
      console.error('Failed to fetch term config:', error);
      setTermConfig(null);
    }
  };

  const fetchCommissionEstimate = async () => {
    try {
      const response = await loanTermAPI.estimateCommission({
        bankId: formData.bankId,
        termMonths: formData.termMonths,
        amount: formData.amount,
      });
      
      if (response.data.success) {
        setCommissionEstimate(response.data.commission);
        // Save commission to formData for use in Step7 summary
        setFormData(prev => ({
          ...prev,
          estimatedCommission: response.data.commission.monthlyCommission,
          commissionPercent: response.data.commission.commissionPercent,
        }));
      } else {
        setCommissionEstimate(null);
        setFormData(prev => ({
          ...prev,
          estimatedCommission: null,
          commissionPercent: null,
        }));
      }
    } catch (error) {
      console.error('Failed to fetch commission estimate:', error);
      setCommissionEstimate(null);
      setFormData(prev => ({
        ...prev,
        estimatedCommission: null,
        commissionPercent: null,
      }));
    }
  };

  const handleTermChange = (e) => {
    const value = parseInt(e.target.value) || 0;
    setFormData((prev) => ({
      ...prev,
      termMonths: value,
    }));
  };

  const handleQuickSelect = (term) => {
    setFormData((prev) => ({
      ...prev,
      termMonths: term,
    }));
  };

  // Calculate estimated monthly payment (simple calculation)
  const calculateMonthlyPayment = () => {
    if (!formData.amount || !formData.termMonths) return 0;
    const principal = formData.amount;
    const months = formData.termMonths;
    const estimatedInterestRate = 0.12; // 12% annual
    const monthlyInterest = (principal * estimatedInterestRate) / 12;
    const monthlyPrincipal = principal / months;
    return Math.round(monthlyPrincipal + monthlyInterest);
  };

  const monthlyPayment = calculateMonthlyPayment();

  return (
    <div className="step-container">
      <div className="form-group">
        <label className="form-label">
          {t('termLabel')} <span className="required">*</span>
        </label>
        <div className="amount-input-wrapper">
          <input
            type="number"
            min="1"
            max="120"
            value={formData.termMonths || ''}
            onChange={handleTermChange}
            placeholder="12"
            className="amount-input"
          />
          <span className="amount-suffix">{t('monthsLabel')}</span>
        </div>
      </div>

      {/* <div className="quick-select">
        <p className="quick-select-label">{t('quickSelect')}:</p>
        <div className="quick-buttons">
          {quickTerms.map((term) => (
            <button
              key={term}
              type="button"
              className={`quick-btn ${formData.termMonths === term ? 'active' : ''}`}
              onClick={() => handleQuickSelect(term)}
            >
              {term}{t('monthsLabel')}
            </button>
          ))}
        </div>
      </div> */}

      {/* {termConfig && formData.amount > 0 && formData.termMonths > 0 && (
        <div className="step-info info">
          📋 <strong>{termConfig.label}</strong>
          <br />
          {t('feeRate')}: <strong>{termConfig.feePercent}%</strong>
          {termConfig.notePercent > 0 && (
            <>
              {' • '}
              {t('noteLabel')}: <strong>{termConfig.notePercent}%</strong>
            </>
          )}
          <br />
          {termConfig.description && (
            <small>{termConfig.description}</small>
          )}
          <br />
          <br />
          💰 {t('estimatedFee')}:
          <strong> {formatCurrency((formData.amount * termConfig.feePercent) / 100)}</strong>
        </div>
      )} */}

      {/* {formData.amount > 0 && formData.termMonths > 0 && (
        <div className="step-info success">
          📊 {t('estimatedMonthlyPayment')}:
          <br />
          <strong>{formatCurrency(monthlyPayment)}</strong>
          <br />
          <small>({t('basedOnInterestRate')})</small>
        </div>
      )} */}

      {commissionEstimate && (
        <div className="step-info success" style={{ marginTop: '12px', background: '#e8f5e9' }}>
          💰 {t('estimatedCommission')}:
          <br />
          <strong>{formatCurrency(commissionEstimate.monthlyCommission || 0)}</strong>
          <span style={{ fontSize: '0.9em' }}></span>
          <br />
          {/* <small>
            ({t('total')}: {formatCurrency((commissionEstimate.monthlyCommission || 0) * formData.termMonths)})
          </small> */}
        </div>
      )}

      {(!formData.termMonths || formData.termMonths < 1) && (
        <div className="step-info warning">
          ⚠️ {t('pleaseEnterTerm')}
        </div>
      )}
    </div>
  );
};

export default Step4Term;
